export function getStatusLabel(status: string): string {
  switch (status) {
    case 'open':
      return 'Open';
    case 'acknowledged':
      return 'Acknowledged';
    case 'investigating':
      return 'Investigating';
    case 'analyzing_code':
      return 'Analyzing Code';
    case 'resolved':
      return 'Analysis Complete';
    case 'remediation_applied':
      return 'Remediation Applied';
    case 'resolved_confirmed':
      return 'Resolved';
    default:
      return status.charAt(0).toUpperCase() + status.slice(1);
  }
}
